import { useEffect, useState } from "react";
import {httpsCallable, getFunctions} from 'firebase/functions';
import { firebaseApp } from "services/DatabaseService";

export interface IPlan {
  id: string;
  cmsId: string;
  title: string;
  features: string;
  onPick: () => void;
  price?: string;
  active?: boolean;
  period?: string;
  recommended?: boolean;
  current?: boolean;
}

interface StaticContent {
  plans: IPlan[];
  terms: string;
}

const kCacheKey = 'static-content';
const readCached = () => {
  const item = localStorage.getItem(kCacheKey);
  if (!item) {
    return {
      plans: [],
      terms: '',
    };
  }
  return {
    ...JSON.parse(item),
    loading: false,
  };
}

const useStaticContent = () => {
  const [state, setState] = useState<StaticContent & {loading: boolean}>({
    loading: true,
    plans: [],
    terms: '',
    ...readCached(),
  });
  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      setState(existing => ({
        ...existing,
        loading: true,
      }));
      const response = await httpsCallable(getFunctions(firebaseApp), 'webGetStaticContent')();
      localStorage.setItem(kCacheKey, JSON.stringify(response.data));
      if (isMounted) {
        setState({loading: false, ...(response.data as StaticContent)});
      }
    }
    fetchData();
    return () => {
      isMounted = false;
    }
  }, []);
  return state;
};

export default useStaticContent;
